import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSuggestQuestionsForTextArgs,
  BackendSuggestQuestionsForTextPayload,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SuggestQuestionsForText(
    $customerId: ID!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestQuestionsForText(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      questions {
        text
        name
      }
    }
  }
`;

type Variables = BackendMutationSuggestQuestionsForTextArgs;
type Result = BackendSuggestQuestionsForTextPayload;

export const suggestQuestionsForText = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
